"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var canvas_1 = require("./canvas");
exports.CanvasCategory = canvas_1.default;
var html_1 = require("./html");
exports.HtmlCategory = html_1.default;
//# sourceMappingURL=index.js.map